import { Badge, Code, Table } from '@workos-inc/design-system';
export const CSV_SCHEMA_ATTRIBUTES = {
  users: {
    required: [{
      name: 'user_id',
      description: 'A unique ID representing the user'
    }, {
      name: 'first_name',
      description: 'The first name of the user'
    }, {
      name: 'last_name',
      description: 'The last name of the user'
    }, {
      name: 'email',
      description: 'The primary work email for the user'
    }],
    optional: [{
      name: 'username',
      description: 'A unique human readable user name'
    }, {
      name: 'job_title',
      description: 'The job title of the user'
    }, {
      name: 'employee_type',
      description: 'The type of employee'
    }, {
      name: 'employment_start_date',
      description: 'The date the user started working'
    }, {
      name: 'display_name',
      description: 'The display name of the user'
    }, {
      name: 'department_name',
      description: 'The name of the department the user belongs to'
    }, {
      name: 'manager_name',
      description: "The name of the user's manager"
    }, {
      name: 'manager_email',
      description: "The email of the user's manager"
    }, {
      name: 'manager_id',
      description: "The identifier of the user's manager from the directory provider"
    }, {
      name: 'division_name',
      description: 'The name of the division the user belongs to'
    }, {
      name: 'cost_center_name',
      description: 'The name of the cost center the user belongs to'
    }, {
      name: 'work_address_street',
      description: 'Work street address'
    }, {
      name: 'work_address_locality',
      description: 'Work city'
    }, {
      name: 'work_address_region',
      description: 'Work state'
    }, {
      name: 'work_address_postal_code',
      description: 'Work postal/zip code'
    }, {
      name: 'work_address_country',
      description: 'Work country'
    }]
  },
  userGroups: {
    required: [{
      name: 'group_name',
      description: 'The name of the group'
    }, {
      name: 'user_id',
      description: 'The ID of the user. Must match the user_id on the users.csv file'
    }]
  },
  groups: {
    required: [{
      name: 'group_name',
      description: 'The name of the group. Must match the group_name on the user_groups.csv file'
    }]
  }
};
export const DirectorySyncCsvSchemaTableUsers = () => <Table.Root data-sentry-element="Table.Root" data-sentry-component="DirectorySyncCsvSchemaTableUsers" data-sentry-source-file="directory-sync-csv-schema-table.tsx">
    <Table.Content data-sentry-element="Table.Content" data-sentry-source-file="directory-sync-csv-schema-table.tsx">
      <Table.Header data-sentry-element="Table.Header" data-sentry-source-file="directory-sync-csv-schema-table.tsx">
        <Table.Row data-sentry-element="Table.Row" data-sentry-source-file="directory-sync-csv-schema-table.tsx">
          <Table.ColumnHeader width="33%" data-sentry-element="Table.ColumnHeader" data-sentry-source-file="directory-sync-csv-schema-table.tsx">CSV Header</Table.ColumnHeader>
          <Table.ColumnHeader data-sentry-element="Table.ColumnHeader" data-sentry-source-file="directory-sync-csv-schema-table.tsx">Status</Table.ColumnHeader>
          <Table.ColumnHeader data-sentry-element="Table.ColumnHeader" data-sentry-source-file="directory-sync-csv-schema-table.tsx">Description</Table.ColumnHeader>
        </Table.Row>
      </Table.Header>
      <Table.Body data-sentry-element="Table.Body" data-sentry-source-file="directory-sync-csv-schema-table.tsx">
        {CSV_SCHEMA_ATTRIBUTES.users.required.map(attribute => <Table.Row key={attribute.name}>
            <Table.RowHeader>
              <Code variant="ghost">{attribute.name}</Code>
            </Table.RowHeader>
            <Table.Cell>
              <Badge color="blue">Required</Badge>
            </Table.Cell>
            <Table.Cell>{attribute.description}</Table.Cell>
          </Table.Row>)}
        {CSV_SCHEMA_ATTRIBUTES.users.optional.map(attribute => <Table.Row key={attribute.name}>
            <Table.RowHeader>
              <Code variant="ghost">{attribute.name}</Code>
            </Table.RowHeader>
            <Table.Cell>
              <Badge color="gray">Optional</Badge>
            </Table.Cell>
            <Table.Cell>{attribute.description}</Table.Cell>
          </Table.Row>)}
      </Table.Body>
    </Table.Content>
  </Table.Root>;
export const DirectorySyncCsvSchemaTableUserGroups = () => <Table.Root data-sentry-element="Table.Root" data-sentry-component="DirectorySyncCsvSchemaTableUserGroups" data-sentry-source-file="directory-sync-csv-schema-table.tsx">
    <Table.Content data-sentry-element="Table.Content" data-sentry-source-file="directory-sync-csv-schema-table.tsx">
      <Table.Header data-sentry-element="Table.Header" data-sentry-source-file="directory-sync-csv-schema-table.tsx">
        <Table.Row data-sentry-element="Table.Row" data-sentry-source-file="directory-sync-csv-schema-table.tsx">
          <Table.ColumnHeader width="33%" data-sentry-element="Table.ColumnHeader" data-sentry-source-file="directory-sync-csv-schema-table.tsx">CSV Header</Table.ColumnHeader>
          <Table.ColumnHeader data-sentry-element="Table.ColumnHeader" data-sentry-source-file="directory-sync-csv-schema-table.tsx">Status</Table.ColumnHeader>
          <Table.ColumnHeader data-sentry-element="Table.ColumnHeader" data-sentry-source-file="directory-sync-csv-schema-table.tsx">Description</Table.ColumnHeader>
        </Table.Row>
      </Table.Header>
      <Table.Body data-sentry-element="Table.Body" data-sentry-source-file="directory-sync-csv-schema-table.tsx">
        {CSV_SCHEMA_ATTRIBUTES.userGroups.required.map(attribute => <Table.Row key={attribute.name}>
            <Table.RowHeader>
              <Code variant="ghost">{attribute.name}</Code>
            </Table.RowHeader>
            <Table.Cell>
              <Badge color="blue">Required</Badge>
            </Table.Cell>
            <Table.Cell>{attribute.description}</Table.Cell>
          </Table.Row>)}
      </Table.Body>
    </Table.Content>
  </Table.Root>;
export const DirectorySyncCsvSchemaTableGroups = () => <Table.Root data-sentry-element="Table.Root" data-sentry-component="DirectorySyncCsvSchemaTableGroups" data-sentry-source-file="directory-sync-csv-schema-table.tsx">
    <Table.Content data-sentry-element="Table.Content" data-sentry-source-file="directory-sync-csv-schema-table.tsx">
      <Table.Header data-sentry-element="Table.Header" data-sentry-source-file="directory-sync-csv-schema-table.tsx">
        <Table.Row data-sentry-element="Table.Row" data-sentry-source-file="directory-sync-csv-schema-table.tsx">
          <Table.ColumnHeader width="33%" data-sentry-element="Table.ColumnHeader" data-sentry-source-file="directory-sync-csv-schema-table.tsx">CSV Header</Table.ColumnHeader>
          <Table.ColumnHeader data-sentry-element="Table.ColumnHeader" data-sentry-source-file="directory-sync-csv-schema-table.tsx">Status</Table.ColumnHeader>
          <Table.ColumnHeader data-sentry-element="Table.ColumnHeader" data-sentry-source-file="directory-sync-csv-schema-table.tsx">Description</Table.ColumnHeader>
        </Table.Row>
      </Table.Header>
      <Table.Body data-sentry-element="Table.Body" data-sentry-source-file="directory-sync-csv-schema-table.tsx">
        {CSV_SCHEMA_ATTRIBUTES.groups.required.map(attribute => <Table.Row key={attribute.name}>
            <Table.RowHeader>
              <Code variant="ghost">{attribute.name}</Code>
            </Table.RowHeader>
            <Table.Cell>
              <Badge color="blue">Required</Badge>
            </Table.Cell>
            <Table.Cell>{attribute.description}</Table.Cell>
          </Table.Row>)}
      </Table.Body>
    </Table.Content>
  </Table.Root>;
export const DirectorySyncCsvSchemaTable = {
  Users: DirectorySyncCsvSchemaTableUsers,
  UserGroups: DirectorySyncCsvSchemaTableUserGroups,
  Groups: DirectorySyncCsvSchemaTableGroups
};